var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.875,
    height: 36.875,
    viewBox: "0 0 36.875 36.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#00a85b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.875,
    height: 36.875,
    rx: 18.438,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35.875,
    height: 35.875,
    rx: 17.938,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.838,16.409a1.681,1.681,0,0,0,1.676,1.676h6.7a1.681,1.681,0,0,0,1.676-1.676V6.352H5.838ZM16.733,3.838H13.8L12.962,3H8.771l-.838.838H5V5.514H16.733Z",
    transform: "translate(7.571 7.895)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove2);
export default __webpack_public_path__ + "static/media/remove2.96756b3f9757caf1009618ceaa135428.svg";
export { ForwardRef as ReactComponent };